import { CtaShell } from "./cta-shell"
import type { CtaShellProps } from "./cta-types"

export type RatingProofCtaProps = CtaShellProps

export function RatingProofCta(props: RatingProofCtaProps) {
  return <CtaShell {...props} layout="card" socialProof={props.socialProof ?? { rating: "4.9/5", reviewCount: "2,100 reviews", count: "Loved by growth teams shipping serious pages" }} />
}
